// Note: Taken from AppConstants.startWorkdayMinHour etc.
export const START_WORKDAY_MIN_HOUR = 7;
export const START_WORKDAY_MAX_HOUR = 13;
export const END_WORKDAY_MIN_HOUR = 13;
export const END_WORKDAY_MAX_HOUR = 20;
